import React from 'react';
import { connect } from 'react-redux';
import { readStates, states } from '@/constants/lifecycle';
import EditAction from '@/components/ribbon-actions/EditAction';
import findResult from '@/utils/resultsHelper';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import AuditAction from '@/audit/components/AuditAction';
import { userGroupUrl } from '@/constants/urls';
import { editUserGroup } from '../actions/usergroups/update';
import { showDeleteUserGroupDialog } from '../actions/usergroups/delete';
import CancelUserGroupAction from './CancelUserGroupAction';
import DuplicateUserGroupAction from './DuplicateUserGroupAction';
import SaveUserGroupAction from './SaveUserGroupAction';

const UserGroupActions = ({
  allowAudit,
  allowCreate,
  allowDelete,
  allowEdit,
  category,
  code,
  isEditing,
  isNew,
  readStatus,
  showDelete,
  showEdit,
  url,
  userGroup,
}) => (
  <>
    {allowEdit && !isEditing && (
      <EditAction
        onClick={() => showEdit(category, code)}
        disabled={readStatus !== states.SUCCESS}
      />
    )}
    {allowEdit && isEditing && !isNew && (<CancelUserGroupAction code={code} category={category} />)}
    {((allowEdit && !isNew) || (allowCreate && isNew)) && (
      <SaveUserGroupAction code={code} category={category} isEditing={isEditing} />
    )}
    {allowCreate && !isNew && (<DuplicateUserGroupAction code={code} category={category} isEditing={isEditing} />)}
    {allowAudit && !isNew && (<AuditAction baseUrl={url} disabled={isEditing} />)}
    {allowDelete && !isNew && (
      <DeleteActionMenu onClick={() => showDelete(userGroup)} disabled={isEditing || readStatus !== states.SUCCESS} />
    )}
  </>
);

const mapStateToProps = ({
  auth: {
    role: {
      permissions: {
        usergroups: {
          create, destroy, update, audit,
        },
      },
    },
  },
  userGroups: { userGroups },
}, { category, code }) => {
  const item = findResult(userGroups, category, code)
      || { isEditing: false, isNew: false, ...readStates };

  return {
    allowAudit: audit,
    allowCreate: create,
    allowDelete: destroy,
    allowEdit: update,
    isEditing: item.isEditing,
    isNew: item.isNew,
    readStatus: item.readStatus,
    url: userGroupUrl(item, '#'),
    userGroup: item,
  };
};

const mapDispatchToProps = {
  showEdit: editUserGroup,
  showDelete: showDeleteUserGroupDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupActions);
